import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { MainNavBarLinkItems } from '../../core/config/nav-bar-link-items.config';
import IIremboUser, {
  _BLANK_PROFILE,
} from '../../core/models/users/irembo-user-model';
import { INavbarLinkItem } from '../../core/models/navbar-link-item.model';
import { AuthService } from '../../core/services/auth.service';
import { Router } from '@angular/router';
import {
  RoleEnumToLabelUtil,
  RolesEnum,
} from '@irembo-andela/irembogov3-common';
import { RoleToLabelPipe } from '../../pipes/role-to-label.pipe';
import { mapRolesEnumToUserRolesEnum } from '../../core/models/users/user-roles.model';

@Component({
  selector: 'irembogov-main-navigation-bar',
  templateUrl: './main-navigation-bar.component.html',
})
export class MainNavigationBarComponent implements OnInit, OnDestroy {
  userProfile: IIremboUser = _BLANK_PROFILE;
  _userProfile!: Subscription;
  isLoggedIn!: boolean;

  navBarItems: INavbarLinkItem[] = [];
  private userRoles: RolesEnum[] = [];
  roleToLabelPipe = new RoleToLabelPipe();

  constructor(private authService: AuthService, private router: Router) {}

  async ngOnInit() {
    this.isLoggedIn = await this.authService.isLoggedIn();
    this._userProfile = this.authService.userProfile$.subscribe(
      (profile: IIremboUser) => {
        this.userProfile = profile;
      }
    );
    this.authService.checkLoginProfile();
    this.loadUserOtherRoles();
  }

  logoutUser() {
    this.authService.logOutUser();
  }

  getMainNavBarLinkItemsForRole(): INavbarLinkItem[] {
    const navbarItems: INavbarLinkItem[] = [];
    Object.keys(MainNavBarLinkItems).forEach((key: string) => {
      const item: INavbarLinkItem = MainNavBarLinkItems[key];
      if (!item.allowedRoles) {
        navbarItems.push(item);
        return;
      }

      if (!this.userProfile?.primaryRole) return;

      if (item.allowedRoles.indexOf(this.userProfile.primaryRole.key) > -1) {
        navbarItems.push(item);
        return;
      }

      return false;
    });

    return navbarItems;
  }

  profilePageRedirect(_: unknown) {
    this.router.navigate(['/profile']);
  }

  ngOnDestroy(): void {
    if (this._userProfile) this._userProfile.unsubscribe();
  }

  private async loadUserOtherRoles(): Promise<void> {
    this.userRoles = await this.authService.loadUserIremboRoles();
  }

  getOtherRoles(): string[] {
    const allowedRoles = [
      RoleEnumToLabelUtil(RolesEnum.ROLE_SUPER_ADMIN),
      RoleEnumToLabelUtil(RolesEnum.ROLE_IREMBOGOV_ADMIN),
      RoleEnumToLabelUtil(RolesEnum.ROLE_PARTNERSHIP_MANAGER),
      RoleEnumToLabelUtil(RolesEnum.ROLE_SERVICE_DISTRIBUTION_MANAGER),
      RoleEnumToLabelUtil(RolesEnum.ROLE_CONTENT_MANAGER),
      RoleEnumToLabelUtil(RolesEnum.ROLE_REPORTS_MANAGER),
    ] as string[];
    return this.userRoles
      .map((role: RolesEnum) => RoleEnumToLabelUtil(role))
      .filter((role: string) => allowedRoles.includes(role));
  }

  onRoleChange(roleLabel: string) {
    const matchingRole = this.userRoles.find(
      (role: RolesEnum) => this.roleToLabelPipe.transform(role) === roleLabel
    );
    if (matchingRole) {
      const matchingUserRole = mapRolesEnumToUserRolesEnum(matchingRole);
      this.userProfile.primaryRole = {
        label: roleLabel,
        key: matchingUserRole,
      };
      this.authService.setActiveRole(this.userProfile.primaryRole);
      this.router.navigate(['/']);
    }
  }
}
